import './AccessDenied.scss'
import { MdOutlineArrowBack, MdOutlineHome, MdOutlineLock } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../ui/Button'
import { Card } from '../../ui/Card'

/** The 403 view, rendered in place of a route the user may not open (ADR 0008). */
export function AccessDenied() {
  const navigate = useNavigate()

  const goBack = () => {
    // D9: one step back (the portal went -3); home when there is no history.
    if (window.history.length <= 1) void navigate('/')
    else void navigate(-1)
  }

  return (
    <div className="access-denied">
      <div className="access-denied__panel">
        <Card as="div">
          <div className="access-denied__body">
            <span className="access-denied__icon" aria-hidden="true">
              <MdOutlineLock />
            </span>
            <p className="access-denied__code" aria-hidden="true">
              403
            </p>
            <h1 className="access-denied__title">Access Denied</h1>
            <p className="access-denied__text">
              You don&apos;t have permission to access this resource. Please contact your
              administrator if you believe this is an error.
            </p>
            <div className="access-denied__actions">
              <Button
                variant="primary"
                icon={<MdOutlineHome />}
                onClick={() => {
                  void navigate('/')
                }}
              >
                Go to Dashboard
              </Button>
              <Button icon={<MdOutlineArrowBack />} onClick={goBack}>
                Go Back
              </Button>
            </div>
          </div>
        </Card>
        <p className="access-denied__caption">Error Code: 403 Forbidden</p>
      </div>
    </div>
  )
}
